import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NumericTextBoxComponent } from '@progress/kendo-angular-inputs';
import { ICellEditorAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'numeric-cell-editor',
  template: `<kendo-numerictextbox #kendoNumericTextbox [spinners]="false" style="width:100%"
                                     [format]="format" [(ngModel)]="value" [decimals]="decimals"></kendo-numerictextbox>`,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FormsModule,
    NumericTextBoxComponent,
  ],
})

export class PxdAgGridNumericEditorComponent implements ICellEditorAngularComp {
  public value: any;
  public decimals: number;
  public format: string;

  public agInit(params: any): void {
    if (params.value) {
      this.value = params.value;
    }
    else {
      this.value = 0;
    }

    if (params.decimals !== null && params.decimals !== undefined) {
      this.decimals = params.decimals;
    }
    else {
      this.decimals = 2;
    }

    if (params.format !== null && params.format !== undefined) {
      this.format = params.format;
    }
    else {
      this.format = "n2";
    }
  }

  public getValue(): any {
    return this.value ? this.value : 0;
  }
}